/* Definition of Enumeration StatusTypes */
const StatusTypes_ENUM = Object.freeze({
  RESTARTS: 'restarts',
  LOADING: 'loading',
  WAITING: 'waiting',
  WAITEDTOOLONG: 'waitedTooLong',
  STALLED: 'stalled',
  DELAYED: 'delayed',
  UNRECOVERABLE: 'unrecoverable',
  BROKEN: 'broken',
  UNAVAILABLE: 'unavailable',
});
exports.StatusTypes_ENUM = StatusTypes_ENUM;

/* Definition of Enumeration DurationTypes */
const DurationTypes_ENUM = Object.freeze({
  STARTINGDURATION: 'startingDuration',
  STARTSTREAMMUTATION: 'startStreamDuration',
  WEBSOCKETSTART: 'websocketStartDuration',
  WEBSOCKETFIRST: 'websocketFirstMessageDuration',
  NEDIASOURCESETUP: 'mediaSourceSetup',
  HTML5VIDEOSETUP: 'html5VideoSetup',
  HTML5VIDEOWAITING: 'html5VideoWaiting',
  HTML5VIDEOACCUMULATEDWAITING: 'html5VideoAccumulatedWaiting',
  LATENCY: 'latency',
  WSLATENCY: 'wslatency',
});
exports.DurationTypes_ENUM = DurationTypes_ENUM;

/* Definition of Enumeration TechnicalErrors */
const TechnicalErrors_ENUM = Object.freeze({
  API: 'apiError',
  WEBSOCKETSTREAMERROR: 'wsStreamError',
  WEBSOCKETTIMEOUT: 'wsTimeout',
  VIDEOMEDIAERROR: 'videoMediaError',
  MEDIASOURCEFAILURE: 'mediaSourceFailure',
  VIDEOPLAYREJECTED: 'videoPlayRejected',
  TIMEOUT: 'videoControllerTimeout',
});
exports.TechnicalErrors_ENUM = TechnicalErrors_ENUM;

/* Definition of Enumeration WebsocketStatus */
const WebsocketStatus_ENUM = Object.freeze({
  OPEN: 'open',
  CLOSED: 'closed',
  ERROR: 'error',
});
exports.WebsocketStatus_ENUM = WebsocketStatus_ENUM;

/* Definition of Enumeration MediaErrors */
const MediaErrors_ENUM = Object.freeze({
  ABORTED: 'aborted',
  NETWORK: 'network error',
  DECODE: 'decoding error',
  UNSUPPORTED: 'format missing or not supported',
  UNKNOWN: 'unknown error',
});
exports.MediaErrors_ENUM = MediaErrors_ENUM;

/* Definition of Enumeration DigitalState */
const DigitalState_ENUM = Object.freeze({
  LOW: 0,
  HIGH: 1,
});
exports.DigitalState_ENUM = DigitalState_ENUM;
